<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"><button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">&#8592;</button></div>
        <div class="col-sm">
          <progress-bar :options="options" :value="100" />
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <h4 class="text-primary" v-html="data.consent.consentHeader"></h4>
          <div v-html="data.consent.topText"></div>
          <hr />
          <div v-html="clarificationText"></div>
          <div class="clearfix"></div>
          <button class="btn btn-cnsnt btn-primary btn-lg btn-block"
            @click="$router.push('/cnfrm')" v-html="data.consent.approveBtnText"></button>
          <div class="clearfix"></div>
          <small class="disclaimer" v-html="data.consent.disclaimerText"></small>
        </div>
        <div class="col-sm"></div>
      </div>
      <div id="terms" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title text-center">{{data.consent.termsAndConditionsLabel}}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p v-html="data.consent.termsAndConditionsText"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'
import $ from 'jquery'

export default {
  name: 'consent',
  components: {},
  data () {
    return {
      data: null,
      language: sessionStorage.getItem('language'),
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          dynamicPosition: false,
          hideText: true
        },
        progress: {
          color: '#82ab5b',
          backgroundColor: '#B8C9B8',
          inverted: false
        },
        layout: {
          height: 15,
          width: !isMobile ? $(window).width() - 600 : $(window).width() - 100,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    }
  },
  computed: {
    clarificationText () {
      if (this.data.consent) {
        return this.data.consent.clarificationText.replace('{termsAndConditions}',
          '<span style="text-decoration: underline; cursor: pointer; color: #007bff" data-toggle="modal" data-target="#terms">' +
            this.data.consent.termsAndConditionsLabel + '</span>')
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          consent(locale: ` + sessionStorage.getItem('language') + `) {
            consentHeader
            topText
            clarificationText
            approveBtnText
            disclaimerText
            termsAndConditionsText
            termsAndConditionsLabel
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
button:disabled {
  opacity: 0.3;
}
.img {
  border-radius: 10px;
  width: 20vw;
  margin-left: auto;
  margin-right: auto;
}
.alert-error {
  display: none;
}
.container {
  padding-bottom: 6vh;
}
.no {
  background: #06755F !important;
  color: #8FD14F !important;
}
.close {
  padding: .5rem;
  margin: -1.2rem -.8rem -1rem -1rem;
  font-size: 2rem;
}
.radio-btn {
  margin-bottom: .2em;
  border-color: #069ccc;
  background: #fff;
  color: #000;
  font-size: 1.1em;
  border-radius: .3rem !important;
  width: 100%;
}
.btn-cnsnt:hover:after {
  content: ' ✔';
}
</style>



// WEBPACK FOOTER //
// src/components/Consent.vue